/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Cart-Toast: Zeigt Benachrichtigung wenn Produkt in den Warenkorb gelegt wird.
 * Dreifache Erkennung: Fetch-Interception + document event + documentElement event
 * Alle Styles inline — kein externes CSS nötig.
 */
(function() {
  var _toastLock = 0; /* Verhindert doppelten Toast */
  var _fetchPending = 0; /* Fetch-Interception läuft → Event-Toast unterdrücken */

  /* ── showToast ── */
  function showToast(name) {
    var now = Date.now();
    if (now - _toastLock < 2000) return; /* Sperre für 2s gegen Doppel-Toast */
    _toastLock = now;

    var old = document.getElementById('cart-toast-notification');
    if (old) old.remove();

    var locale = (document.documentElement.lang || 'de').toLowerCase();
    var msg;
    if (locale.indexOf('nl') === 0) {
      msg = name ? '<strong>' + name + '</strong> is toegevoegd aan de winkelwagen' : 'Product is toegevoegd aan de winkelwagen';
    } else if (locale.indexOf('en') === 0) {
      msg = name ? '<strong>' + name + '</strong> has been added to your cart' : 'Product has been added to your cart';
    } else {
      msg = name ? '<strong>' + name + '</strong> wurde in den Warenkorb gelegt' : 'Produkt wurde in den Warenkorb gelegt';
    }

    var toast = document.createElement('div');
    toast.id = 'cart-toast-notification';
    toast.setAttribute('style',
      'position:fixed;bottom:24px;right:24px;z-index:2147483647;' +
      'transform:translateY(80px);opacity:0;' +
      'transition:transform .4s cubic-bezier(.22,1,.36,1),opacity .4s ease;' +
      'pointer-events:none;max-width:400px;font-family:inherit;'
    );
    toast.innerHTML =
      '<div style="display:flex;align-items:center;gap:12px;background:rgba(0,0,0,.88);color:#fff;' +
        'padding:14px 22px;border-radius:8px;' +
        'box-shadow:0 4px 20px rgba(0,0,0,.25);' +
        'font-size:14px;line-height:1.5;">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" style="flex-shrink:0;">' +
          '<circle cx="12" cy="12" r="11" stroke="#4caf50" stroke-width="2"/>' +
          '<polyline points="7 12 10.5 15.5 17 9" stroke="#4caf50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
        '</svg>' +
        '<span>' + msg + '</span>' +
      '</div>';
    document.body.appendChild(toast);

    /* Einblenden */
    setTimeout(function() {
      toast.setAttribute('style',
        'position:fixed;bottom:24px;right:24px;z-index:2147483647;' +
        'transform:translateY(0);opacity:1;' +
        'transition:transform .4s cubic-bezier(.22,1,.36,1),opacity .4s ease;' +
        'pointer-events:auto;max-width:400px;font-family:inherit;'
      );
    }, 30);

    /* Ausblenden nach 4s */
    setTimeout(function() {
      toast.setAttribute('style',
        'position:fixed;bottom:24px;right:24px;z-index:2147483647;' +
        'transform:translateY(80px);opacity:0;' +
        'transition:transform .4s cubic-bezier(.22,1,.36,1),opacity .4s ease;' +
        'pointer-events:none;max-width:400px;font-family:inherit;'
      );
      setTimeout(function() { if (toast.parentNode) toast.remove(); }, 500);
    }, 4000);
  }

  /* ── Methode 1: Fetch Interception ── */
  try {
    var _origFetch = window.fetch;
    window.fetch = function() {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
      var opts = args[1] || {};
      var method = (opts.method || 'GET').toUpperCase();

      var promise = _origFetch.apply(this, args);

      if (method === 'POST' && url.indexOf('/cart/add') !== -1) {
        _fetchPending = Date.now();
        promise.then(function(response) {
          if (response.ok) {
            response.clone().json().then(function(data) {
              _fetchPending = 0;
              var name = null;
              if (data && data.items && data.items.length) {
                name = data.items[0].title || data.items[0].product_title;
              } else if (data) {
                name = data.title || data.product_title;
              }
              showToast(name);
            }).catch(function() { _fetchPending = 0; showToast(null); });
          } else {
            _fetchPending = 0;
          }
        }).catch(function() { _fetchPending = 0; });
      }

      return promise;
    };
  } catch(e) { /* Fetch-Interception nicht möglich */ }

  /* ── Methode 2+3: Event-Listener als Fallback ── */
  function onProductAdded(e) {
    if (e.detail && e.detail.productAdded === false) return;
    /* Wenn Fetch-Interception aktiv ist, hat die den echten Produktnamen → Event-Toast skippen */
    if (_fetchPending && (Date.now() - _fetchPending) < 5000) return;
    /* Name aus DOM extrahieren */
    var name = null;
    var btn = e.detail && e.detail.button;
    if (btn) {
      var card = btn.closest('.product-item');
      if (card) {
        var t = card.querySelector('.product-item__title');
        if (t) name = t.textContent.trim();
      }
      if (!name) {
        var sec = btn.closest('[data-section-type="product"]');
        if (sec) {
          var m = sec.querySelector('.product-meta__title');
          if (m) name = m.textContent.trim();
        }
      }
    }
    if (!name) {
      var h = document.querySelector('.product-meta__title');
      if (h) name = h.textContent.trim();
    }
    showToast(name);
  }

  document.addEventListener('product:added', onProductAdded);
  document.documentElement.addEventListener('product:added', onProductAdded);
})();

/**
 * Shared Sample Modal für Produktkarten (Collection/Search)
 * Erstellt EIN Modal (an <body>), nutzt gleiche CSS-Klassen wie Produktseiten-Modal.
 */
(function() {
  var modal = null;
  var lastFocus = null;

  /* ── i18n ── */
  var i18n = {
    de: {
      title: 'Muster bestellen',
      intro: 'Naturstein ist ein Unikat \u2013 jedes St\u00fcck variiert in Farbe, Maserung und Struktur. Mit einem Muster k\u00f6nnen Sie die Optik und Haptik des Materials vor dem Kauf erleben und die perfekte Variante f\u00fcr Ihr Projekt ausw\u00e4hlen.',
      size: 'Muster ca. 20\u00d720 cm',
      feat1: 'Sie erhalten zu jedem bestellten 1. Muster einer Sorte ein weiteres Musterst\u00fcck kostenlos dazu',
      feat2: 'Farbe und Haptik vor dem Kauf pr\u00fcfen',
      feat3: 'Kostenloser Versand',
      tax: 'inkl. MwSt.',
      btn: 'Muster in den Warenkorb',
      adding: 'Wird hinzugef\u00fcgt\u2026',
      added: '\u2713 Hinzugef\u00fcgt!',
      error: 'Fehler \u2013 erneut versuchen',
      close: 'Schlie\u00dfen'
    },
    nl: {
      title: 'Monster bestellen',
      intro: 'Natuursteen is uniek \u2013 elk stuk varieert in kleur, nerven en structuur. Met een monster kunt u de uitstraling en textuur van het materiaal voor aankoop ervaren en de perfecte variant voor uw project kiezen.',
      size: 'Monster ca. 20\u00d720 cm',
      feat1: 'U ontvangt bij elk 1e besteld monster van een soort een extra monster gratis',
      feat2: 'Kleur en textuur voor aankoop controleren',
      feat3: 'Gratis verzending',
      tax: 'incl. btw',
      btn: 'Monster in winkelwagen',
      adding: 'Wordt toegevoegd\u2026',
      added: '\u2713 Toegevoegd!',
      error: 'Fout \u2013 probeer opnieuw',
      close: 'Sluiten'
    },
    en: {
      title: 'Order Sample',
      intro: 'Natural stone is unique \u2013 each piece varies in color, veining, and structure. With a sample, you can experience the look and feel of the material before purchase and choose the perfect variant for your project.',
      size: 'Sample approx. 20\u00d720 cm',
      feat1: 'You receive an additional sample piece free with every 1st sample of a type ordered',
      feat2: 'Check color and texture before purchase',
      feat3: 'Free shipping',
      tax: 'incl. VAT',
      btn: 'Add sample to cart',
      adding: 'Adding\u2026',
      added: '\u2713 Added!',
      error: 'Error \u2013 try again',
      close: 'Close'
    }
  };

  function t(locale) { return i18n[locale] || i18n.de; }

  /* ── Modal HTML erstellen (gleiche Klassen wie product-buy-buttons) ── */
  function createModal() {
    var d = document.createElement('div');
    d.id = 'sample-modal-shared';
    d.className = 'sample-modal';
    d.setAttribute('role', 'dialog');
    d.setAttribute('aria-modal', 'true');
    d.innerHTML =
      '<div class="sample-modal__dialog">' +
        '<header class="sample-modal__header">' +
          '<h2 class="sample-modal__title"></h2>' +
          '<button type="button" class="sample-modal__close" aria-label="Schlie\u00dfen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
        '</header>' +
        '<div class="sample-modal__content">' +
          '<div class="sample-intro"><p class="sample-intro__text"></p></div>' +
          '<div class="sample-card">' +
            '<h3 class="sample-card__title"></h3>' +
            '<ul class="sample-card__features"><li></li><li></li><li></li></ul>' +
            '<p class="sample-card__price"><span class="sample-card__price-value">\u20ac5,95</span> <span class="sample-card__price-tax"></span></p>' +
            '<button class="button button--primary sample-card__button"></button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(d);
    return d;
  }

  /* ── \u00d6ffnen ── */
  function openModal(trigger) {
    if (!modal) modal = createModal();

    var locale = trigger.dataset.locale || 'de';
    var txt = t(locale);

    modal.querySelector('.sample-modal__title').textContent = txt.title;
    modal.querySelector('.sample-modal__close').setAttribute('aria-label', txt.close);
    modal.querySelector('.sample-intro__text').textContent = txt.intro;
    modal.querySelector('.sample-card__title').textContent = txt.size;
    var lis = modal.querySelectorAll('.sample-card__features li');
    lis[0].textContent = txt.feat1;
    lis[1].textContent = txt.feat2;
    lis[2].textContent = txt.feat3;
    modal.querySelector('.sample-card__price-tax').textContent = txt.tax;

    var btn = modal.querySelector('.sample-card__button');
    btn.textContent = txt.btn;
    btn.disabled = false;
    btn.classList.remove('is-loading');
    btn._locale = locale;
    btn._productUrl = trigger.dataset.productUrl;
    btn._sampleParts = trigger.dataset.sampleUrlParts.split('|');

    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    modal.querySelector('.sample-modal__close').focus();
  }

  /* ── Schlie\u00dfen ── */
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  /* ── Events ── */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-action="open-sample-modal-card"]');
    if (trigger) { e.preventDefault(); e.stopPropagation(); openModal(trigger); return; }
    if (!modal) return;
    if (e.target.closest('.sample-modal__close')) { closeModal(); return; }
    if (e.target === modal) closeModal();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
  });

  /* ── In den Warenkorb ── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('#sample-modal-shared .sample-card__button');
    if (!btn) return;
    e.preventDefault();

    var locale = btn._locale || 'de';
    var txt = t(locale);
    var originalText = txt.btn;
    var parts = btn._sampleParts;
    var productUrl = btn._productUrl;

    btn.classList.add('is-loading');
    btn.disabled = true;
    btn.textContent = txt.adding;

    /* Muster-URL bauen */
    var musterUrl;
    if (productUrl.indexOf('/nl/') !== -1 || productUrl.indexOf('/en/') !== -1) {
      musterUrl = '/' + parts[1] + '/' + parts[2] + '/muster-' + parts[3];
    } else {
      musterUrl = '/' + parts[1] + '/muster-' + parts[2];
    }

    fetch(musterUrl, { method: 'HEAD', redirect: 'follow' })
      .then(function(r) { return fetch(r.url.split('?')[0] + '.js'); })
      .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function(muster) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: muster.variants[0].id, quantity: 1 })
        });
      })
      .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function() {
        btn.textContent = txt.added;
        closeModal();

        /* Cart-Count aktualisieren */
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count')
            .forEach(function(c) { c.textContent = cart.item_count; });
        });
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true, detail: { quantity: 1, productAdded: true }
        }));

        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
          btn.classList.remove('is-loading');
        }, 1200);
      })
      .catch(function(err) {
        console.error('Muster-Fehler:', err);
        btn.textContent = txt.error;
        btn.classList.remove('is-loading');
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      });
  });
})();

